var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.75L19.5 20.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7807 10.6586C10.311 10.7317 9.84885 10.8473 9.39997 11.0038C9.27843 11.0472 9.17027 11.1215 9.08616 11.2194C9.00204 11.3173 8.94487 11.4354 8.92026 11.5621L8.3673 14.3284C8.34285 14.4508 8.28826 14.5651 8.20847 14.661C8.12869 14.7569 8.02624 14.8314 7.91039 14.8778L3.47484 16.652C3.32456 16.7127 3.15864 16.7228 3.00207 16.681C2.8455 16.6392 2.70676 16.5476 2.60676 16.4201C1.93698 15.554 1.60584 14.4735 1.67534 13.3809C1.74485 12.2883 2.21023 11.2584 2.98436 10.4842C4.35386 9.11073 6.0198 8.06921 7.85435 7.43958",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2993 6.76927C13.0892 6.66876 14.8802 6.94779 16.5547 7.58807C18.2292 8.22836 19.7494 9.21542 21.0156 10.4845C21.7898 11.2587 22.2552 12.2886 22.3247 13.3812C22.3942 14.4738 22.063 15.5543 21.3932 16.4204C21.2932 16.5479 21.1545 16.6395 20.9979 16.6813C20.8414 16.7231 20.6754 16.7129 20.5252 16.6523L20.1456 16.5004",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSlash);
export default __webpack_public_path__ + "static/media/phone_slash.b7566e52ee020abd8d0e63cf119324df.svg";
export { ForwardRef as ReactComponent };